import { Component } from '@angular/core'
import { Router } from '@angular/router'

@Component({
    selector: 'app-redefine-about',
    templateUrl: './redefine-about.component.html',
    styleUrls: ['./redefine-about.component.scss'],
})
export class RedefineAboutComponent {
    constructor(private router: Router) {}

    viewAllProperties(): void {
        // No query param needed - map page detects enterprise from domain
        this.router.navigate(['/map-search'])
    }
}

